import { render } from "./SettingsLabelSets.vue?vue&type=template&id=3ffa47c8"
import script from "./SettingsLabelSets.vue?vue&type=script&lang=js"
export * from "./SettingsLabelSets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__